import { FN_DTO_BASE__try_assert_standard_fields } from './FN_DTO_BASE__try_assert_standard_fields';

export function FN_DTO_BASE__try_assert_standard_fields_array(possible_dto_array: any) {
  if (!Array.isArray(possible_dto_array)) return;

  for (let possible_dto of possible_dto_array) {
    FN_DTO_BASE__try_assert_standard_fields(possible_dto);
  }
}
